import styled from 'styled-components';

import { Tag } from '#@/components/Tag';
import { COLOR, GRADIENT } from '#@/shared/utils/styles';

export const StyledTag = styled(Tag)`
  background: ${GRADIENT.subcontractorPremium};
  color: ${COLOR.white};
  height: max-content;
`;

export const PremiumCircleIconWrapper = styled.div`
  width: 42px;
  height: 42px;
  position: relative;
  border-radius: 21px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PremiumCircleIconBackground = styled.div`
  position: absolute;
  width: 42px;
  height: 42px;
  background: ${GRADIENT.subcontractorPremium};
  opacity: 0.05;
`;
